import chroma from "chroma-js";
// add as global, so one can easily test out new colors using the browser dev-tools
globalThis.chroma = chroma;
export class Skin {
}
//# sourceMappingURL=Skin.js.map